import styled, { keyframes } from "styled-components";
import { colors } from "../../libs/themes";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const pulse = keyframes`
    0%, 100% {
        opacity: 0.3;
        transform: scale(1);
    }
    50% {
        opacity: 0.5;
        transform: scale(1.1);
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 600px;
    padding: 60px 20px;
    position: relative;
    overflow: hidden;
`;

export const ContentWrapper = styled.div`
    max-width: 600px;
    width: 100%;
    text-align: center;
    animation: ${fadeIn} 0.8s ease-out;
    position: relative;
    z-index: 1;
`;

export const IconWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(63, 63, 63, 0.1), rgba(11, 11, 11, 0.05));
    border: 3px solid rgba(0, 0, 0, 0.3);
    margin-bottom: 32px;
    color: ${({ theme }) => theme.cardText};
    
    svg {
        opacity: 0.7;
    }
`;

export const Title = styled.div`
    font-size: 32px;
    font-weight: 700;
    color: ${({ theme }) => theme.cardText};
    margin: 0 0 16px 0;
    line-height: 1.2;

    @media (max-width: 768px) {
        font-size: 28px;
    }
`;

export const Message = styled.div`
    font-size: 18px;
    color: ${({ theme }) => theme.cardTextAlt};
    line-height: 1.6;
    margin: 0 0 40px 0;
    max-width: 480px;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

export const InfoCard = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));
    border: 1px solid rgba(184, 249, 79, 0.2);
    border-radius: 16px;
    padding: 24px;
    box-shadow: ${colors.shadow.cardLight};
    text-align: left;
    max-width: 480px;
    margin: 0 auto;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
`;

export const InfoIcon = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(184, 249, 79, 0.2), rgba(184, 249, 79, 0.1));
    color: ${({ theme }) => theme.cardText};
`;

export const InfoText = styled.div`
    margin: 0;
    font-size: 15px;
    color: ${({ theme }) => theme.cardTextAlt};
    line-height: 1.6;
    flex: 1;
`;

interface DecorativeCircleProps {
    position: "top-left" | "bottom-right";
}

export const DecorativeCircle = styled.div<DecorativeCircleProps>`
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(184, 249, 79, 0.08), rgba(184, 249, 79, 0.03));
    pointer-events: none;
    animation: ${pulse} 4s ease-in-out infinite;
    z-index: 0;

    ${({ position }) =>
        position === "top-left"
            ? `
        top: -150px;
        left: -150px;
    `
            : `
        bottom: -150px;
        right: -150px;
        animation-delay: 2s;
    `}

    @media (max-width: 768px) {
        width: 200px;
        height: 200px;
        
        ${({ position }) =>
            position === "top-left"
                ? `
            top: -100px;
            left: -100px;
        `
                : `
            bottom: -100px;
            right: -100px;
        `}
    }
`;
